import type { MaybeRefOrGetter } from 'vue';
import type { GlobalCollectionId } from '#layers/data-model';
import { computed, toValue } from 'vue';
import { useProjectSchemaStore } from '#imports';

export function useCollection(collectionId: MaybeRefOrGetter<GlobalCollectionId | null | undefined>) {
	const { findCollectionById } = useProjectSchemaStore();

	return {
		collection: computed(() => {
			const id = toValue(collectionId);
			return id ? findCollectionById(id) : undefined;
		}),
	};
}

export function useCollectionByName(collectionName: MaybeRefOrGetter<string | null | undefined>) {
	const { findCollectionByName } = useProjectSchemaStore();

	return {
		collection: computed(() => {
			const name = toValue(collectionName);
			return name ? findCollectionByName(name) : undefined;
		}),
	};
}
